import React from 'react';
import CategoryRow from '../CategoryRow';

const Sport = () => (
  <CategoryRow title="Sports Equipment" category="Sports Equipment" exploreTo="/all-sport-item" />
);

export default Sport;
